/**
 * @license
 * Copyright Alibaba.com All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ant-reset-private/blob/master/LICENSE
 */

import { NgModule } from '@angular/core';
import { NzIconDirective } from './nz-icon.directive';

@NgModule({
  exports: [NzIconDirective],
  declarations: [NzIconDirective]
})
export class NzIconModule {}
